import { HighlightsSearchObject } from "@/modules/care-provider/utils/combine-care-provider-title"

export const getHighlightValue = (
  highlights?: HighlightsSearchObject,
  value?: string,
  defaultValue?: string | null,
) => {
  return highlights?.find((h) => h.key === value)?.value ?? defaultValue
}
